import { Check, Sparkles } from 'lucide-react';

import CommonDialog from '../Common/Dialog';

const STEPS = [
  'Extracting data from your resume',
  'Analysing ATS compatibility'
];

const AILoader = () => (
  <div className='mb-6 flex h-14 w-14 items-center justify-center'>
    <div className='flex h-11 w-11 animate-pulse items-center justify-center rounded-full bg-gradient-to-br from-primary to-beta shadow-boxShadowOne'>
      <Sparkles size={22} className='text-white' strokeWidth={2} />
    </div>
  </div>
);

const BoostATSAnalyzing = ({
  isOpen,
  completedStep
}: {
  isOpen: boolean;
  completedStep: number;
}) => {
  return (
    <CommonDialog
      isOpen={isOpen}
      dialogTitle='Analysing Your Resume'
      width='w-full max-w-[440px]'
      hideClose
    >
      <div className='flex flex-col items-center py-4'>
        <AILoader />

        <div className='w-full space-y-3'>
          {STEPS.map((step, idx) => {
            const isDone = idx < completedStep;
            const isActive = idx === completedStep;
            return (
              <div
                key={step}
                className={`flex items-center gap-3 rounded-lg px-4 py-2 text-sm transition-all ${
                  isActive
                    ? 'bg-gamma font-medium text-primary'
                    : isDone
                      ? 'text-gray-500'
                      : 'text-gray-300'
                }`}
              >
                <div
                  className={`flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-xs ${
                    isDone
                      ? 'bg-green-100 text-green-600'
                      : isActive
                        ? 'bg-primary/10 text-primary'
                        : 'bg-gray-100 text-gray-300'
                  }`}
                >
                  {isDone ? <Check size={12} /> : idx + 1}
                </div>
                {step}
              </div>
            );
          })}
        </div>

        <p className='mt-6 text-xs text-gray-400'>
          AI is analysing your resume&hellip;
        </p>
      </div>
    </CommonDialog>
  );
};

export default BoostATSAnalyzing;
